<template>
  <b-card-code title="Form Upload UMKM ">
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <b-button variant="primary" v-b-modal.modal-upload>
              <feather-icon icon="UploadIcon" class="mr-50" />
              <span class="align-middle">Upload Excel</span>
            </b-button>
            <umkmUpload />
          </b-col>

          <!-- Search -->
          <b-col cols="12" md="6">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Masukan UMKM.."
              />
              <b-button variant="primary" @click="getData()">
                <span class="text-nowrap">Search</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
      <div>
        <b-row>
          <b-col cols="12">
            <b-col sm="12" class="my-2 mr-4">
              <b-table-simple striped hover style="font-size:80%">
                <b-thead>
                  <b-tr>
                    <b-th
                      v-for="(h, index) in header"
                      :width="h.width"
                      :key="index"
                    >
                      {{ h.title }}
                    </b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr v-for="item in umkmPage" :key="item.id">
                    <b-td class="align-middle" style="width:10%">
                      {{ item.bumnName }}
                    </b-td>
                    <b-td class="align-middle" style="width:10%">
                      {{ item.nama_UMKM }}
                    </b-td>
                    <b-td class="align-middle">{{ item.alamat }} </b-td>
                    <b-td class="align-middle">
                      {{ item.kota }}
                    </b-td>
                    <b-td class="align-middle">
                      {{ item.no_Telp }}
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-col></b-col
          >
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Total {{ total }} </span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="total"
              :per-page="pageSize"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
              @input="getData()"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-modal
      id="modal-upload"
      ref="my-modal"
      title="Upload Excel"
      centered
      ok-title="Submit"
      cancel-variant="outline-secondary"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          :state="fileState"
          label="Upload Files"
          label-for="name-input"
          invalid-feedback="File is required"
        >
          <b-form-file
            id="file-input"
            v-model="file"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            :state="fileState"
            required
          ></b-form-file>
        </b-form-group>
      </form>
    </b-modal>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@core/utils/validations/validations';
import umkmUpload from '@/assets/templete/umkmupload.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    umkmUpload,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 1,
      pageSize: 10,
      totalUsers: 1,
      searchQuery: '',
      fileState: null,
      file: null,
      required,
      header: [
        {
          title: 'BUMN',
          value: 'BUMN',
          width: '10%',
        },
        {
          title: 'Nama UMKM',
          value: 'Nama UMKM',
          width: '20%',
        },
        {
          title: 'Alamat',
          value: 'Alamat',
          width: '30%',
        },
        {
          title: 'Kota',
          value: 'Kota',
          width: '10%',
        },
        {
          title: 'HP',
          value: 'HP',
          width: '10%',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('umkm', ['umkmPage', 'total']),
  },
  async created() {
    await this.getData();
  },
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.fileState = valid;
      return valid;
    },
    async getData() {
      await this.$store.dispatch('umkm/getUmkmPage', {
        page: this.currentPage,
        namaUMKM: this.searchQuery,
      });
    },
    resetModal() {
      this.file = null;
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    async save() {
      let formData = new FormData();

      formData.append('file', this.file);
      const response = await this.$store.dispatch('umkm/uploadUmkm', {
        data: formData,
      });

      if (response.status == 200) {
        this.$swal
          .fire('Data Berhasil di Disimpan!', '', 'success')
          .then(() => {
            this.getData();
          });
      } else {
        console.log(response.response);
        this.$swal.fire({
          icon: 'error',
          title: 'Validasi.',
          text: response.response.data.errorMessages,
        });
      }
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return;
      }
      // Push the name to submitted names
      this.save();
      // Hide the modal manually
      this.$nextTick(() => {
        this.$refs['my-modal'].toggle('#toggle-btn');
      });
    },
  },
};
</script>
